import { Button, Icon, Modal } from '@octano/global-ui';
import { forwardRef, useImperativeHandle, useState } from 'react';
import { Container } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { TranslationsKeys } from '../../../../locales/translations';

interface Props {
  onConfirm: (data: any) => void;
  onDecline: () => void;
}

export interface ConfirmModalRef {
  openModal: (row: any) => void;
  closeModal: () => void;
}

const ConfirmModal = forwardRef<ConfirmModalRef, Props>(
  ({ onConfirm, onDecline }, ref) => {
    const { t } = useTranslation(
      TranslationsKeys.MANAGEMENT_TOOLS_SURVEY_EVALUATION_SCALES,
    );
    const [data, setData] = useState<any>();
    const [modal, setModal] = useState(false);

    useImperativeHandle(ref, () => ({
      openModal(row: any) {
        setData(row);
        setModal(true);
      },
      closeModal() {
        setModal(false);
      },
    }));

    return (
      <Modal isOpen={modal} toggle={() => setModal(false)}>
        <Container fluid className="text-center">
          <Icon name="information" size={45} />

          <h1 className="text-dark fs-20 mt-5 mb-5">
            {t('confirmDelete.title')}
          </h1>

          <div className="d-flex justify-content-around" style={{ gap: 10 }}>
            <Button
              className="w-100"
              outlined
              text={t('confirmDelete.cancel')}
              onClick={() => {
                onDecline();
                setModal(false);
              }}
            />
            <Button
              className="w-100"
              text={t('confirmDelete.confirm')}
              onClick={() => {
                onConfirm(data!);
                setModal(false);
              }}
            />
          </div>
        </Container>
      </Modal>
    );
  },
);

export default ConfirmModal;
